<template>
  <v-stepper v-model="step" alt-labels>
    <v-overlay :value="$store.getters['game/suspended'] || endGame" absolute>
      <v-sheet v-if="endGame"  color="primary" class="pa-4">{{$t('general.gameFinished')}}</v-sheet>
      <v-sheet v-else color="primary" class="pa-4">{{$t('general.gamePaused')}}</v-sheet>
    </v-overlay>
    <v-alert
      class="ma-4 animated bounceIn"
      v-if="$store.getters['game/test']"
      type="warning"
    >{{$t('general.testMode')}}</v-alert>
    
    <v-stepper-header>
      <v-stepper-step v-if="$store.getters['company/ddOn']" :complete="step > 0" step="0">{{$t('steps.bufferSetup')}}</v-stepper-step>

      <v-divider v-if="$store.getters['company/ddOn']"></v-divider>

      <v-stepper-step :complete="step > 1" step="1">{{$t('steps.clientOrder')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 2" step="2">{{$t('steps.clientShipment')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 3" step="3">{{$t('steps.supplierShimpentWaiting')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 4" step="4">{{$store.getters['company/productionCompany'] ? $t('steps.productionShipments') : $t('steps.supplierShipments')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 5" step="5">{{$t('steps.board')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 6" step="6">{{$store.getters['company/productionCompany'] ? $t('steps.productionBatch') : $t('steps.supplierOrders')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 7" step="7">{{$t('steps.board')}}</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <buffer-setup :timeLeft="timeLeft" :step="step"></buffer-setup>
      <clients-requests :timeLeft="timeLeft" :step="step"></clients-requests>
      <client-shipment :timeLeft="timeLeft" :step="step"></client-shipment>
      <board :timeLeft="timeLeft" :step="step" :stepNbr="3"></board>
      <supplier-shipment :timeLeft="timeLeft" :step="step"></supplier-shipment>
      <board :timeLeft="timeLeft" :step="step" :stepNbr="5"></board>
      <supplier-order :timeLeft="timeLeft" :step="step"></supplier-order>
      <board :timeLeft="timeLeft" :step="step" :stepNbr="7"></board>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import ClientsRequests from './ClientsRequests'
import ClientShipment from './ClientShipment'
import Board from './Board'
import SupplierShipment from './SupplierShipment'
import SupplierOrder from './SupplierOrder'
import BufferSetup from './BufferSetup'
export default {
  components: {
    ClientsRequests,
    ClientShipment,
    Board,
    SupplierShipment,
    SupplierOrder,
    BufferSetup
  },
  props: {
    active: Boolean
  },
  data: () => ({
    timer: 0,
    timeLeft: 1
  }),
  mounted() {
    if (this.step != 3 && this.step != 5 && this.step != 7) {
      this.initTimer()
    }
  },
  methods: {
    initTimer () {
      this.timeLeft = this.$store.getters['game/timerCount']
      this.timer = setInterval(() => {
        this.timeLeft--
        if (this.timeLeft == 0) {
          this.cancelTimer()
        }
      }, 1000)
    },
    cancelTimer () {
      clearInterval(this.timer)
    }
  },
  computed: {
    step ()  {
      return this.$store.state.company.data ? this.$store.state.company.data.step : 0
    },
    endGame () {
      return this.$store.getters['game/status'] == 2 && this.step == 7
    }
  },
  watch: {
    step (val) {
      this.cancelTimer()
      if (val != 3 && val != 7) {
        this.initTimer()
      } else {
        this.timeLeft = 1
      }
    }
  }
};
</script>

<style>
.v-stepper__label{
  text-align: center !important;
}
.test-mode{
  background: url('/images/test-background.png');
}
</style>